import React, { useState } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import './Contacts.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.email && formData.message) {
      // Simulate form submission
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      setTimeout(() => setSubmitted(false), 5000); // clear success alert after 5s
    }
  };

  return (
    <div className="contact-page-container container py-5">
      <h2 className="text-center mb-3 contact-title text-gradient text-uppercase">Contact Us</h2>
      <p className="lead text-center text-muted mb-5">
        The Chandigarh Badminton Association is always open to connecting with players, parents, sponsors, and enthusiasts.
      </p>

      <Row className="gy-4">
        {/* Left Column - Contact Information */}
        <Col lg={5}>
          <div className="contact-info-card">
            <h4 className="fw-bold mb-4" style={{ color: 'var(--yonex-blue)' }}>Representative Contact</h4>
            <p className="text-muted small mb-4">
              If you have any questions regarding registration, upcoming tournaments, training facilities, or membership details, please get in touch with our team representative.
            </p>

            <div className="contact-info-item">
              <div className="contact-info-icon-box">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
                </svg>
              </div>
              <div>
                <div className="contact-info-label">Representative Name</div>
                <h5 className="contact-info-value">Surinder Mahajan</h5>
                <p className="text-muted small mb-0">Senior Vice President (Administration)</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon-box">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                </svg>
              </div>
              <div>
                <div className="contact-info-label">Phone Number</div>
                <h5 className="contact-info-value">+91-9815045900</h5>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon-box">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                </svg>
              </div>
              <div>
                <div className="contact-info-label">Office Address</div>
                <h5 className="contact-info-value">#1143, Sector 37-B, Chandigarh</h5>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon-box">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                </svg>
              </div>
              <div>
                <div className="contact-info-label">Email Address</div>
                <h5 className="contact-info-value">mahajan_surinder@hotmail.com</h5>
              </div>
            </div>
          </div>
        </Col>

        {/* Right Column - Feedback Form */}
        <Col lg={7}>
          <div className="contact-form-card">
            <h4 className="contact-form-title">Send a Message</h4>
            
            {submitted && (
              <Alert variant="success" className="mb-4">
                🎉 Thank you for getting in touch! Your message has been sent successfully. We will contact you shortly.
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <Row>
                <Col md={6} className="form-group-custom">
                  <label htmlFor="name" className="form-label-custom">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control-custom"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </Col>
                <Col md={6} className="form-group-custom">
                  <label htmlFor="email" className="form-label-custom">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control-custom"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </Col>
              </Row>

              <div className="form-group-custom">
                <label htmlFor="subject" className="form-label-custom">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="form-control-custom"
                  placeholder="What is this inquiry about?"
                  value={formData.subject}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group-custom">
                <label htmlFor="message" className="form-label-custom">Message Details</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-control-custom"
                  placeholder="Write your message here..."
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <button type="submit" className="btn btn-yonex-green w-100 py-3 text-uppercase mt-2">
                Submit Message
              </button>
            </form>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Contact;
